const checkAccessLevel = (type) => (state) => {
  const {
    marketplace: {
      layersNavigation: {
        category,
        area,
      },
      accessLevel,
    },
  } = state


  if (category === 'edu' || category === 'rpc') {
    const categoryAccessLevel = accessLevel[category] || {}
    const hasAccess           = type === categoryAccessLevel.status

    if (type === 'customer') {
      return !/^(admin|cashier)$/.test(categoryAccessLevel.status)
    }

    return hasAccess
  }

  // if (category === 'sport') {
    const categoryAccessLevel = accessLevel[category || 'sport'] || {}
    const accessToAreas       = (categoryAccessLevel.areas || []).map(({ id }) => id)
    const isCustomer          = categoryAccessLevel.status === 'customer' || !accessToAreas.includes(area)

    if (isCustomer) {
      return type === 'customer'
    }

    return type === categoryAccessLevel.status
  // }
}


export default checkAccessLevel